import React, { useState } from 'react';
import TerminosLegales from '../TerminosLegales/terminosLegales.component'

const Footer = (props) => {
    const [tipoDoc, setTipoDoc] = useState();
    const [showModal, setShowModal] = useState(false);
    const [loader, setLoader] = useState(true);
    return (
        <>
            <div className="footer">
                <div className="logo">
                    <img src="/static/media/logo.e4bea988.png" alt="" />
                </div>
                <div className="info">
                    <div className="directorios">
                        <div>
                            <h4>PBX</h4>
                            <h5>01 8000 51 59 59</h5>
                        </div>
                        <div>
                            <h4>Email</h4>
                            <h5>serviciocliente@postobon.com.co</h5>
                        </div>
                        <div>
                            <h4>Whatsapp</h4>
                            <h5>+57 315 2003046</h5>
                        </div>
                        <div>
                            <h4>Contactenos</h4>
                            <h5>https://www.postobon.com/formulario/rosita</h5>
                        </div>
                    </div>
                    <div className="contactos">
                        <a style={{ cursor: 'pointer' }} onClick={() => window.location.href = "./PreguntasFrecuentes"}>Preguntas frecuentes</a>
                        <a
                            href={window.location.pathname+"#openModal"}
                            onClick={() => {
                                setTipoDoc(1)
                                setShowModal(true)
                            }}
                             >Política de tratamiento de datos</a>
                        <a
                            href={window.location.pathname+"#openModal"}
                            onClick={() => {
                                setTipoDoc(5)
                                setShowModal(true)
                            }} >Términos y condiciones</a>

                        <a href="">Contáctenos</a>
                        <a href="https://www.postobon.com/">www.postobon.com</a>
                    </div>
                </div>
                <div className="redes">
                    <div>
                        <div className="icon-red"><a href="https://twitter.com/postobonoficial?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank"> <i className="fab fa-twitter">  </i> </a></div>
                        <div className="icon-red"><a href="https://www.facebook.com/Postobon" target="_blank"> <i className="fab fa-facebook-f"> </i> </a></div>
                        <div className="icon-red"><a href="https://www.instagram.com/postobonempresa/" target="_blank"> <i className="fab fa-instagram"> </i> </a></div>
                        <div className="icon-red"><a href="https://www.youtube.com/user/UnoMasTodos" target="_blank"> <i className="fab fa-youtube"> </i> </a></div>
                    </div>
                </div>
                {showModal ?
                    <TerminosLegales tipoDoc={tipoDoc} updateShowModal={setShowModal}></TerminosLegales>
                    : null }
            </div>
        </>

    )

}

export default Footer;